import { Component, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MoovInstanceData, MoovInstanceEventData, MoovInstanceStepData, MoovStepData, MoovViewData } from '../../../services/challenge/challenges-data';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AbstractChallengesService } from '../../../services/challenge/challenges.abstract.service';
import { PersonalUserData } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { EventEmitter } from '@angular/core';
import { MoovData } from '../../../services/challenge/challenges-data';
import { TranslateService } from '@ngx-translate/core';
import { MotivationFullDetails } from 'src/app/all-motivations/model/all-motivations.interface';
import { AbstractMotivationsService } from 'src/app/moov-common/services/motivation/motivations.abstract.service';
import { MotivationPartialViewComponent } from '../../motivation-partial-view/motivation-partial-view/motivation-partial-view.component';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { MoovStepInstanceState, MoovTypeEnum } from 'src/app/moov-common/services/challenge/moovStepState.enum';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-moov-view',
  templateUrl: './moov-view.component.html',
  styleUrls: ['./moov-view.component.scss']
})
export class MoovViewComponent extends BaseComponent
implements OnInit {
@Input() moovViewDetails: MoovViewData;
@Input() moovDetails: MoovData;
@Input() activeMoovDetails: MoovInstanceData;
@Input() isPastMoov: boolean;
@Input() isActiveMoov: boolean;
@Input() counterpartId: string;
@Input() showClose: boolean = true;
@Output() activeMoovEnded = new EventEmitter();
@Output() moovActivated = new EventEmitter();
@Output() moovExtended = new EventEmitter();
@Output() closeEvent = new EventEmitter()

counterpartDetails: PersonalUserData;
pastMoovs: MoovInstanceData[];
moovsImagesRootFolder = 'assets/moovs/';
commonImagesRootFolder = 'assets/common/';
isImportant:boolean;
hasPastMoovs: boolean;
isEndingMoovInProcess: boolean;
timeLeftText: string;
moovRating: number;
feedbackText: string;
motivationPartialData: MotivationFullDetails;
userEntryText: string;
activeMoovEvents: MoovInstanceEventData[] = [];
moovSteps: MoovStepData[];
activeMoovSteps: MoovInstanceStepData[] = [];
mv_false = false;
showMoreReasoningDetails : boolean = false;
showMoreDetailsButtonHeader : string = "";
reasoningText : string = "";
activeMoovPresentSteps: boolean = true;
activeMoovPresentJournal : boolean = false;
isSimpleView = true;

constructor(private readonly challengesService: AbstractChallengesService, 
            private readonly motivationsService: AbstractMotivationsService,
            private readonly personalDetailsService: AbstractPersonalUserDataService,
            public translate: TranslateService,
            public dialog: MatDialog) {
  super();
  this.pastMoovs = [];
  this.isImportant = false;
  this.hasPastMoovs = false;
  this.feedbackText = "";
  this.moovRating = 3; 
 }

ngOnInit(): void {
  super.ngOnInit();

  if (this.moovViewDetails != undefined){

    this.moovDetails = this.moovViewDetails.moovDetails;
    this.isActiveMoov = this.moovViewDetails.isActiveMoov;
    this.isPastMoov = this.moovViewDetails.isPastMoov;
    this.moovSteps = this.moovDetails.steps;

    // console.log (`in MV moovdetails = ${JSON.stringify(this.moovDetails)}`);

    if (this.moovViewDetails.activeMoovDetails != undefined){
      this.activeMoovDetails = this.moovViewDetails.activeMoovDetails;
    }

    if (this.moovViewDetails.counterpartId != undefined){
      this.counterpartId = this.moovViewDetails.counterpartId;
    }

    if (this.isActiveMoov){
      this.isImportant = this.activeMoovDetails.isImportant;
      this.activeMoovEvents = this.activeMoovDetails.events;
      this.activeMoovSteps = this.activeMoovDetails.steps;
    }
    else{
      this.isImportant = this.moovDetails.score > 50;
    }

    this.motivationPartialData = this.motivationsService.getPartialMotivationDetails(this.moovDetails.motivationId!);
    this.calculateReasoningView();
  }

  this.getCounterpartDetails();
  this.setTimeLeftforMoovText(); 

  this.isSimpleView = this.moovDetails.moovType == MoovTypeEnum.Short;
  // console.log(`MV onInit isSimpleView ${JSON.stringify(this.isSimpleView)} moov is ${JSON.stringify(this.moovDetails)}`);

  if (this.isActiveMoov){
    // console.log (`in MV events are ${JSON.stringify(this.activeMoovDetails.events)}`);
  }
}

ngOnChanges(changes: SimpleChanges) : void {
    if (changes.moovViewDetails.currentValue != changes.moovViewDetails.previousValue && !changes.moovViewDetails.firstChange){
      this.moovDetails = this.moovViewDetails.moovDetails;
      this.isActiveMoov = this.moovViewDetails.isActiveMoov;
      this.isPastMoov = this.moovViewDetails.isPastMoov;
      this.moovSteps = this.moovDetails.steps;
      this.isSimpleView = this.moovDetails.moovType == MoovTypeEnum.Short;
  
      if (this.moovViewDetails.activeMoovDetails != undefined){
        this.activeMoovDetails = this.moovViewDetails.activeMoovDetails;
      }
  
      if (this.moovViewDetails.counterpartId != undefined){
        this.counterpartId = this.moovViewDetails.counterpartId;
      }

      if (this.isActiveMoov){
        this.isImportant = this.activeMoovDetails.isImportant;
        this.activeMoovEvents = this.activeMoovDetails.events;
        this.activeMoovSteps = this.activeMoovDetails.steps;
      }
      else{
        this.isImportant = this.moovDetails.score > 50;
      }
      this.isEndingMoovInProcess = false;
    
      this.setTimeLeftforMoovText();   
      this.motivationPartialData = this.motivationsService.getPartialMotivationDetails(this.moovDetails.motivationId!);

      if (this.motivationPartialData != undefined){
        // console.log(`in MV changes motivation partial data is ${this.motivationPartialData}`);
      }
      else{
        // console.log(`in MV changes motivation partial data undefiend`);
      }

      this.getPastMoovs();
      this.getCounterpartDetails();
      this.calculateReasoningView();
    }
}

setTimeLeftforMoovText(){
  if (!this.isPastMoov && this.isActiveMoov){
    if (!this.activeMoovDetails.isOverdue){
      const plannedEndDate = new Date(this.activeMoovDetails.plannedEndDate);
      const currentTime = new Date();
      const daysLeft = Math.round((plannedEndDate.getTime() - currentTime.getTime())/(3600*24*1000));

      // console.log (`in setTimeLeftForMoov planned ${plannedEndDate.getTime()} days left ${daysLeft}`);

      if (daysLeft > 1) {
        if (daysLeft === 2) {
          this.timeLeftText = this.translate.instant("moovView.dueIn2Days");
        } else {
          this.timeLeftText = this.translate.instant("moovView.dueIn", { value: daysLeft });
        }
      }
      else if (daysLeft === 1)
      {
        this.timeLeftText = this.translate.instant("moovView.dueTomorrow");
      }
      else{
        this.timeLeftText = this.translate.instant("moovView.dueToday");
      }
    }
    else{
      this.timeLeftText = this.translate.instant("moovView.overdue");;
    }
  }
}

openMotivation(): void{
  this.dialog.open(MotivationPartialViewComponent, {
    height: '500px',
    width: '600px',
    data: {selectedMotivationId:this.motivationPartialData.id, isRTL:this.isRTL, isSelf:false}
  });
}

extendActiveMoov(): void{
  // console.log (`in extend active moov #1`);
  if (!this.isActiveMoov){
    return;
  }

  // console.log (`in extend active moov #2`);

  // call the service to extend the active moov time - and update data 
  this.challengesService.extendActiveMoov(this.activeMoovDetails.id).subscribe(updatedActiveMoov => {
    this.activeMoovDetails = updatedActiveMoov;
    this.activeMoovEvents = this.activeMoovDetails.events;
    this.moovSteps = this.moovDetails.steps;
    this.activeMoovSteps = this.activeMoovDetails.steps;

    this.setTimeLeftforMoovText();
    this.analytics.activeMoovExtendedEvent(this.counterpartId, this.moovDetails.issueId!, this.moovDetails.id, this.activeMoovDetails.id);
    this.moovExtended.emit(this.moovDetails.id);
  })
}

onRatingChanged(rating: number) {
  this.moovRating = rating;
}

activateMoov() : void{
  // activate this moov and close the side Nav
  this.challengesService.activateMoov(this.moovDetails.id, this.counterpartDetails.id, this.moovDetails.isMoovForSelf).subscribe(updatedActiveMoov => {
    // updates order matters as component different parts are refreshing by this
    // this.activeMoovDetails = updatedActiveMoov;
    // this.isPastMoov = false;
    // this.isActiveMoov = true;
    this.analytics.makeMoovEvent(this.counterpartId, this.moovDetails.id, this.moovDetails.issueId!, updatedActiveMoov.id);
    this.moovActivated.emit(this.moovDetails.id);
  })
}

redoMoov() : void{
  this.activateMoov();
}

getCounterpartDetails() : void{
  if (this.counterpartId != undefined){
    this.personalDetailsService.getUserDetails(this.counterpartId).subscribe(userDetails =>{
      this.counterpartDetails = userDetails;
    });
  }
}

getPastMoovs(): void{
  if (this.counterpartId == undefined || this.moovDetails == undefined){
    return;
  }

  this.challengesService.getPastMoovsforMoovAndCounterpart(this.counterpartId, this.moovDetails.id).subscribe(pastMoovs =>{
    this.pastMoovs = pastMoovs;
  });
}

startEndMoovProcess(): void {
  this.isEndingMoovInProcess = true;
}

endMoov(): void{
    // let feedbackText = (<HTMLInputElement>document.getElementById('moovFeedbackInput')).value;
    // console.log(`in endMoov score is ${this.moovRating} text is ${this.feedbackText}`);
  this.analytics.moovFeedback(this.moovDetails.id,this.activeMoovDetails.id, this.moovRating, this.counterpartId);
    this.challengesService.endMoov(this.activeMoovDetails.id, this.moovRating, this.feedbackText).subscribe(endMoov => {
      this.activeMoovEnded.emit(this.activeMoovDetails.id);
      this.feedbackText = "";
      this.moovRating = 3;
      this.analytics.activeMoovEndedEvent(this.counterpartId, this.moovDetails.issueId!, this.moovDetails.id, this.activeMoovDetails.id);
      })
  } 
  
  addUserEntry(): void{
    this.challengesService.addUserEventToMoov(this.activeMoovDetails.id, this.userEntryText ).subscribe(activeMoov => {
        this.activeMoovDetails = activeMoov;
        this.activeMoovEvents = activeMoov.events;

        // Reset user text in edit box
        this.userEntryText = "";
    });
  }

  timeAgo(date: Date) : string{
    return this.utilsService.dateToTimeAgo(date);
  }
  
  isActiveStep(stepIdx:number):boolean{
    if (this.activeMoovDetails.steps[stepIdx].state==MoovStepInstanceState.Done){
      return false;
    }
    else if (stepIdx == 0){
      return true;
    }
    else if (stepIdx > 0 && this.activeMoovDetails.steps[stepIdx-1].state==MoovStepInstanceState.Done){
      return true;
    }
    else{
      return false;
    }
  }

  setStepAsDone(stepIdx:number) :void{
    this.challengesService.setStepAsDone(this.activeMoovDetails.id, this.activeMoovDetails.steps[stepIdx].id).subscribe(activeMoov => {
      this.moovViewDetails.activeMoovDetails = activeMoov;
      // console.log(`in MV setStepAsDone activeMoov.events = ${JSON.stringify(activeMoov.events)}`);
      this.ngOnInit();
    });
  }

  setStepAsPending(stepIdx:number) :void{
    this.challengesService.setStepAsPending(this.activeMoovDetails.id, this.activeMoovDetails.steps[stepIdx].id).subscribe(activeMoov => {
      this.moovViewDetails.activeMoovDetails = activeMoov;

      // console.log(`in MV setStepAsPending activeMoov.events = ${JSON.stringify(activeMoov.events)} this.activeMoovDetails.events = ${JSON.stringify(this.activeMoovDetails.events)}`);
      this.ngOnInit();
    });
  }

  calculateReasoningView(){
    if (this.showMoreReasoningDetails){
      this.showMoreDetailsButtonHeader = this.translate.instant("common.showLessTextLabel");
      this.reasoningText = this.moovViewDetails.moovDetails.reasoning;
    } 
    else{
      this.showMoreDetailsButtonHeader = this.translate.instant("common.showMoreTextLabel")
      this.reasoningText = this.moovViewDetails.moovDetails.reasoning.substring(0, 48);

      if (this.reasoningText.length < this.moovViewDetails.moovDetails.reasoning.length ){
        this.reasoningText += "...";
      }
    }
  }

  toggleShowReasoningDetails(){
    this.showMoreReasoningDetails = !this.showMoreReasoningDetails;
    this.calculateReasoningView();
  }

  setCommentToStep(stepIdx:number) :void{
    this.challengesService.addUserCommentToStep(this.activeMoovDetails.id, this.activeMoovDetails.steps[stepIdx].id, this.activeMoovDetails.steps[stepIdx].comment).subscribe(activeMoov => {
      this.moovViewDetails.activeMoovDetails = activeMoov;
      this.ngOnInit();
    });
  }

  closeView() : void{
    console.log('in mv closeView');
    this.closeEvent.emit();
  }

  presentStepsSelected(): void{
    this.activeMoovPresentSteps = true;
    this.activeMoovPresentJournal = false;
  }

  presentJournalSelected(): void{
    this.activeMoovPresentSteps = false;
    this.activeMoovPresentJournal = true;
  }

}